var render = function () {
  var _vm$me, _vm$me2;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "500"
    },
    model: {
      value: _vm.show,
      callback: function callback($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_c('v-card', {
    staticClass: "v-card--dialog"
  }, [_c('v-btn', {
    staticClass: "v-card--dialog__close",
    attrs: {
      "fab": "",
      "color": "transparent"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1), _c('div', {
    staticClass: "v-card--dialog__body"
  }, [_c('section', {
    staticClass: "page-section page-section--sm pt-0"
  }, [_c('div', {
    staticClass: "mb-10px"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("회원검색")])]), _c('div', [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-text-field', {
    attrs: {
      "placeholder": "이름 또는 아이디",
      "append-icon": "mdi-magnify",
      "outlined": "",
      "hide-details": "",
      "clearable": ""
    },
    on: {
      "input": _vm.search
    },
    model: {
      value: _vm.filter.searchValue,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "searchValue", $$v);
      },
      expression: "filter.searchValue"
    }
  })], 1)], 1)], 1)]), _c('section', {
    staticClass: "page-section page-section--sm"
  }, [_c('div', {
    staticClass: "mb-10px mb-md-20px"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("최근선물한 회원")]), _c('v-divider', {
    staticClass: "grey lighten-1 mt-10px"
  })], 1), _c('div', [(_vm$me = _vm.me) !== null && _vm$me !== void 0 && _vm$me.recentUser.length ? _c('v-list', {
    attrs: {
      "outlined": ""
    },
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }, _vm._l((_vm$me2 = _vm.me) === null || _vm$me2 === void 0 ? void 0 : _vm$me2.recentUser, function (user, index) {
    var _vm$selected;

    return _c('v-list-item', {
      key: index,
      staticClass: "py-1",
      attrs: {
        "value": user
      },
      on: {
        "click": function click($event) {
          _vm.selected = user;
        }
      }
    }, [_c('v-list-item-avatar', {
      attrs: {
        "color": "primary"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "white"
      }
    }, [_vm._v("mdi-account")])], 1), _c('v-list-item-title', [_c('div', [_vm._v(_vm._s(user.name) + " (" + _vm._s(user.username) + ")")]), _c('v-list-item-subtitle', {
      staticClass: "pb-1"
    }, [_c('div', [_vm._v(_vm._s(String((user === null || user === void 0 ? void 0 : user.phone) || "").replace(/[^0-9]/g, '').replace(/([0-9]{3}).+([0-9]{4})/g, "$1****$2").phoneNumberFormat()))])])], 1), _c('v-list-item-action', [_vm.selected && ((_vm$selected = _vm.selected) === null || _vm$selected === void 0 ? void 0 : _vm$selected.username) == (user === null || user === void 0 ? void 0 : user.username) ? _c('v-icon', [_vm._v("mdi-check")]) : _vm._e()], 1), _c('v-list-item-action', {
      on: {
        "click": function click($event) {
          return _vm.remove(user._id, index);
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1);
  }), 1) : _vm._e()], 1)]), _c('section', {
    staticClass: "page-section page-section--sm"
  }, [_c('div', {
    staticClass: "mb-10px mb-md-20px"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("회원선택")]), _c('v-divider', {
    staticClass: "grey lighten-1 mt-10px"
  })], 1), _c('div', [_vm.members.length ? _c('v-list', {
    attrs: {
      "outlined": ""
    },
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }, _vm._l(_vm.members, function (member, index) {
    var _vm$selected2;

    return _c('v-list-item', {
      key: index,
      staticClass: "py-1",
      attrs: {
        "value": member
      },
      on: {
        "click": function click($event) {
          _vm.selected = member;
        }
      }
    }, [_c('v-list-item-avatar', {
      attrs: {
        "color": "primary"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "white"
      }
    }, [_vm._v("mdi-account")])], 1), _c('v-list-item-title', [_c('div', [_vm._v(_vm._s(member.name) + " (" + _vm._s(member.username) + ")")]), _c('v-list-item-subtitle', {
      staticClass: "pb-1"
    }, [_c('div', [_vm._v(_vm._s(member.phone.phoneNumberFormat()))])])], 1), _c('v-list-item-action', [_vm.selected && ((_vm$selected2 = _vm.selected) === null || _vm$selected2 === void 0 ? void 0 : _vm$selected2.username) == (member === null || member === void 0 ? void 0 : member.username) ? _c('v-icon', [_vm._v("mdi-check")]) : _vm._e()], 1)], 1);
  }), 1) : _vm._e()], 1)])]), _c('div', {
    staticClass: "v-card--dialog__foot"
  }, [_c('div', {
    staticClass: "v-card--dialog__foot"
  }, [_c('v-row', {
    staticClass: "row--x-small"
  }, [_c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.select
    }
  }, [_vm._v("선택")])], 1)], 1)], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }